export default function deleteRoleReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'DELETE_ROLE_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'DELETE_ROLE_ERROR':
      return {...state, ...{error: action.error}};

    case 'DELETE_ROLE_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}